export default "__VITE_ASSET__CrNCx1l7__"